export interface CounterCustomerChargeSearchCriteria {

    chgTypeList?: string[] | null,
    subChgTypeList?: string[] | null,
    opsLines?: string[] | null,
    opsDateFrom?: Date | null,
    opsDateTo?: Date | null,
    co?: string | null,
    vsl?: string | null,
    voy?: string | null,
    cntrList?: string[] | null,
    chgOnCompList?: string[] | null,
    billToCompList?: string[] | null,
    billOfLadingNo?: string | null,
    shippingBill?: string | null,
    agentNo?: string | null,
    states?: string[] | null,
    serviceRequestCode?: string | null,
    subServiceRequestCode?: string | null,
    serviceRequestRef?: string | null,
    chargeId?: number[] | null,
    singleMultipleInfoMap?: { [key: string]: object },
    trainId?: string | null,

    [key: string]: string[] | number[] | string | boolean | number | Date | null | undefined | { [key: string]: object }
}

export const EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA: CounterCustomerChargeSearchCriteria = {

    chgTypeList: [],
    subChgTypeList: [],
    opsLines: [],
    opsDateFrom: null,
    opsDateTo: null,
    co: null,
    vsl: null,
    voy: null,
    cntrList: [],
    chgOnCompList: [],
    billToCompList: [],
    billOfLadingNo: null,
    shippingBill: null,
    agentNo: null,
    states: [],
    serviceRequestCode: null,
    subServiceRequestCode: null,
    serviceRequestRef: null,
    chargeId: [],
    singleMultipleInfoMap: {},
    trainId: null,
}